/*       */

import { gql } from '@apollo/client';
import loadWorkspaceDetailsCommonQuery from 'graphql/workspaces/loadWorkspaceDetailsCommonQuery';

export default gql`
    mutation addWorkspaceClassesMutation($id: ID!, $classes: [ID]!) {
        result: workspaceAddClasses(id: $id, classes: $classes) {
            ${loadWorkspaceDetailsCommonQuery}
        }
    }
`;
